import React from "react";
import "./Testimonial.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { AiFillStar } from "react-icons/ai";

export default function Testimonial() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <section id="testimonials" className="testimonials section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Testimonials</h2>
          <p className="contact-para">What they are saying about us</p>
        </div>

        <div
          className="testimonials-slider swiper"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div className="swiper-wrapper">
            <Slider {...settings}>
              <div className="swiper-slide">
                <div className="testimonial-item">
                  <div className="review">
                    <p>
                      Outstanding web developer! Created a sleek and
                      user-friendly site that exceeded our expectations. A true
                      professional in the field.
                    </p>
                  </div>
                  <div className="profile mt-2">
                    <h3>Amit Singh</h3>
                    <h4>Lucknow</h4>
                    <div className="stars">
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                    </div>
                  </div>
                </div>
              </div>

              <div className="swiper-slide">
                <div className="testimonial-item">
                  <div className="review">
                    <p>
                      Impressive web development skills! Built a robust,
                      SEO-optimized website that boosted our online presence.
                      Great communication and problem-solving.
                    </p>
                  </div>
                  <div className="profile mt-auto">
                    <h3>Sunil Bhatt</h3>
                    <h4>Mumbai</h4>
                    <div className="stars">
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                    </div>
                  </div>
                </div>
              </div>

              <div className="swiper-slide">
                <div className="testimonial-item">
                  <div className="review">
                    <p>
                      Exceptional web developer with a strong grasp of the
                      latest trends. Crafted a visually stunning and
                      fast-loading site. A pleasure to work with!
                    </p>
                  </div>
                  <div className="profile mt-auto">
                    <h3>Naina Kesarwani</h3>
                    <h4>Mumbai</h4>
                    <div className="stars">
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                    </div>
                  </div>
                </div>
              </div>

              <div className="swiper-slide">
                <div className="testimonial-item">
                  <div className="review">
                    <p>
                      Highly skilled web developer who transformed our ideas
                      into a functional masterpiece. Dependable,
                      detail-oriented, and consistently delivers top-notch
                      results.
                    </p>
                  </div>
                  <div className="profile mt-auto">
                    <h3>Pankaj Chaubey</h3>
                    <h4>Uttar Pradesh</h4>
                    <div className="stars">
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                      <AiFillStar />
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}
